import Hotjar from '@hotjar/browser'

import { getRuntimeEnv } from '../../runtime-env'
import type { ConsentService } from '../types'

let initAttempted = false
let initialized = false

function getHotjarIds(): { siteId: number; hotjarVersion: number } | null {
  const siteId = Number(getRuntimeEnv('VITE_HOTJAR_SITE_ID'))
  const hotjarVersion = Number(getRuntimeEnv('VITE_HOTJAR_VERSION') ?? '6')

  if (!Number.isFinite(siteId) || siteId <= 0) return null
  if (!Number.isFinite(hotjarVersion) || hotjarVersion <= 0) return null

  return { siteId, hotjarVersion }
}

export const hotjarService: ConsentService = {
  category: 'statistics',

  init() {
    if (initAttempted) return
    initAttempted = true

    const ids = getHotjarIds()
    if (!ids) {
      // eslint-disable-next-line no-console
      console.warn('[consent] Hotjar skipped: missing VITE_HOTJAR_SITE_ID or VITE_HOTJAR_VERSION')
      return
    }

    initialized = Hotjar.init(ids.siteId, ids.hotjarVersion)
  },

  trackPageView(path: string) {
    if (!initialized) return
    Hotjar.stateChange(path)
  },
}
